// extracted by mini-css-extract-plugin
module.exports = {"container":"_7b5aeeb"};